const toRating = (value) => {
  const rating = Number(value);
  return Number.isFinite(rating) && rating > 0 ? rating : null;
};

export default function RatingBadge({ rating, reviewCount = null, compact = false }) {
  const value = toRating(rating);
  if (!value) return compact ? null : <span className="hv-no-review-badge">No reviews yet</span>;

  const count = Number(reviewCount);
  const hasCount = Number.isFinite(count) && count > 0;
  return (
    <span className="hv-rating-badge" aria-label={`${value.toFixed(1)} rating${hasCount ? ` from ${count} reviews` : ''}`}>
      <span aria-hidden="true">&#9733;</span>
      <strong>{value.toFixed(1)}</strong>
      {hasCount ? <span>{count.toLocaleString('en-IN')} reviews</span> : null}
    </span>
  );
}
